// extracted by mini-css-extract-plugin
module.exports = {"normalChart":"NormalChart_normalChart__2gseU","chartBlock":"NormalChart_chartBlock__eP-Ga","title":"NormalChart_title__1BP3z"};